import { render, staticRenderFns } from "./NumberWithDescription.vue?vue&type=template&id=60994184&scoped=true&lang=pug&"
import script from "./NumberWithDescription.vue?vue&type=script&lang=js&"
export * from "./NumberWithDescription.vue?vue&type=script&lang=js&"
import style0 from "./NumberWithDescription.vue?vue&type=style&index=0&id=60994184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60994184",
  null
  
)

export default component.exports